import CryptoJS from 'crypto-js';
import JSEncrypt from 'jsencrypt';
var Crypt = /*#__PURE__*/function () {
  function Crypt(publicKey, iv, key) {
    var _this = this;
    this.iv = void 0;
    this.key = void 0;
    this.publicKey = void 0;
    this.aes_decrypt = function (text) {
      if (text) {
        try {
          var decode = CryptoJS.AES.decrypt(text, CryptoJS.enc.Utf8.parse(_this.key), {
            iv: CryptoJS.enc.Utf8.parse(_this.iv),
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7
          });
          return decode.toString(CryptoJS.enc.Utf8);
        } catch (err) {
          return err;
        }
      }
      return '';
    };
    this.rsa_key_encrypt = function () {
      var encrypt = new JSEncrypt();
      encrypt.setPublicKey(_this.publicKey);
      return encrypt.encrypt(JSON.stringify({
        iv: _this.iv,
        key: _this.key
      })); // 把Key进行非对称加密
    };
    this.publicKey = publicKey;
    this.iv = iv != null ? iv : CryptoJS.lib.WordArray.random(128 / 16).toString(CryptoJS.enc.Hex);
    this.key = key != null ? key : CryptoJS.lib.WordArray.random(128 / 8).toString(CryptoJS.enc.Hex);
  }
  var _proto = Crypt.prototype;
  _proto.aes_encrypt = function aes_encrypt(text) {
    if (text) {
      try {
        var encoded = CryptoJS.AES.encrypt(text, CryptoJS.enc.Utf8.parse(this.key), {
          iv: CryptoJS.enc.Utf8.parse(this.iv),
          mode: CryptoJS.mode.CBC,
          padding: CryptoJS.pad.Pkcs7
        });
        return encoded.toString();
      } catch (err) {
        return err;
      }
    }
    return '';
  };
  return Crypt;
}();
export { Crypt as default };